'use strict';

var expandingSectionHeader = $('.experience-commerce_layouts-collapsibleMobileGrid3r3c .text-heading');


$(expandingSectionHeader).on("click", function () {

    var expandingSection = $(this).parent();
    var expandingSectionContent = $(this).prev();


    if (!$(expandingSection).hasClass('expanded')) {
        $(expandingSection).addClass('expanded');
    } else {
        $(expandingSection).removeClass('expanded');
    }

    $(expandingSectionContent).slideToggle( "slow", function() {
            //After Slide
      });
});